import { Component, Input, OnInit } from '@angular/core';
import { FireCmpViewmodel } from '../fire-cmp-viewmodel';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';

@Component({
  selector: 'app-fire-cmp',
  templateUrl: './fire-cmp.component.html',
  styleUrls: ['./fire-cmp.component.css']
})
export class FireCmpComponent implements OnInit {
  @Input()
  isReadOnly = false;
  @Input()
  fireCmpViewModel: FireCmpViewmodel;

  fireServiceSelectedControl: FormControl;
  fireServiceSizeControl: FormControl;
  fireServiceFlowControl: FormControl;
  fireServiceQtyControl: FormControl;

  boosterYesControl: FormControl;
  boosterNoControl: FormControl;
  boosterControlGroup: FormGroup;

  fireServiceYesControl: FormControl;
  fireServiceNoControl: FormControl;
  fireServiceControlGroup: FormGroup;

  hydrantYesControl: FormControl;
  hydrantNoControl: FormControl;
  hydrantControlGroup: FormGroup;

  sprinklerYesControl: FormControl;
  sprinklerNoControl: FormControl;
  sprinklerControlGroup: FormGroup;

  hoseReelYesControl: FormControl;
  hoseReelNoControl: FormControl;
  hoseReelControlGroup: FormGroup;

  pumpYesControl: FormControl;
  pumpNoControl: FormControl;
  pumpControlGroup: FormGroup;

  tankYesControl: FormControl;
  tankNoControl: FormControl;
  tankControlGroup: FormGroup;

  designStandardsControl: FormControl;
  designStandardsControlMaxLength = 100;

  maximumFireServiceSize = 200;
  maximumFireServiceFlowRate = 40;
  maximumFireServiceQty = 20;

  errorMessage: string;

  constructor() {
    this.fireCmpViewModel = new FireCmpViewmodel();

    this.fireServiceYesControl = new FormControl();
    this.fireServiceNoControl = new FormControl();
    this.fireServiceControlGroup = new FormGroup({
      yes: this.fireServiceYesControl,
      no: this.fireServiceNoControl
    }, (g: FormGroup): ValidationErrors => {
      return {
        yesOrNo: !g.controls.yes.value && !g.controls.no.value
      };
    });

    this.fireServiceSelectedControl = new FormControl();
    this.fireServiceSizeControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumFireServiceSize)])]);
    this.fireServiceFlowControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumFireServiceFlowRate)])]);
    this.fireServiceQtyControl = new FormControl('',
      [Validators.compose([Validators.min(0), Validators.max(this.maximumFireServiceQty)])]);

    this.boosterYesControl = new FormControl();
    this.boosterNoControl = new FormControl();
    this.boosterControlGroup = new FormGroup({
      yes: this.boosterYesControl,
      no: this.boosterNoControl
    }, (g: FormGroup): ValidationErrors => {
      return {
        yesOrNo: !g.controls.yes.value && !g.controls.no.value
      };
    });

    this.hydrantYesControl = new FormControl();
    this.hydrantNoControl = new FormControl();
    this.hydrantControlGroup = new FormGroup({
      yes: this.hydrantYesControl,
      no: this.hydrantNoControl
    }, (g: FormGroup): ValidationErrors => {
      return {
        yesOrNo: !g.controls.yes.value && !g.controls.no.value
      };
    });

    this.sprinklerYesControl = new FormControl();
    this.sprinklerNoControl = new FormControl();
    this.sprinklerControlGroup = new FormGroup({
      yes: this.sprinklerYesControl,
      no: this.sprinklerNoControl
    }, (g: FormGroup): ValidationErrors => {
      return {
        yesOrNo: !g.controls.yes.value && !g.controls.no.value
      };
    });

    this.hoseReelYesControl = new FormControl();
    this.hoseReelNoControl = new FormControl();
    this.hoseReelControlGroup = new FormGroup({
      yes: this.hoseReelYesControl,
      no: this.hoseReelNoControl
    }, (g: FormGroup): ValidationErrors => {
      return {
        yesOrNo: !g.controls.yes.value && !g.controls.no.value
      };
    });

    this.pumpYesControl = new FormControl();
    this.pumpNoControl = new FormControl();
    this.pumpControlGroup = new FormGroup({
      yes: this.pumpYesControl,
      no: this.pumpNoControl
    }, (g: FormGroup): ValidationErrors => {
      return {
        yesOrNo: !g.controls.yes.value && !g.controls.no.value
      };
    });

    this.tankYesControl = new FormControl();
    this.tankNoControl = new FormControl();
    this.tankControlGroup = new FormGroup({
      yes: this.tankYesControl,
      no: this.tankNoControl
    }, (g: FormGroup): ValidationErrors => {
      return {
        yesOrNo: !g.controls.yes.value && !g.controls.no.value
      };
    });

    this.designStandardsControl = new FormControl('', [
      Validators.maxLength(this.designStandardsControlMaxLength)
    ]);
  }

  ngOnInit() {
  }
  get fireServiceYes(): boolean {
    return this.fireCmpViewModel.fireServiceYes;
  }


  get fireServiceNo(): boolean {
    return this.fireCmpViewModel.fireServiceNo;
  }

  get fireServiceSelected(): boolean {
    return this.fireCmpViewModel.fireServiceSelected;
  }

  set fireServiceSelected(v: boolean) {
    this.fireCmpViewModel.fireServiceSelected = v;
  }

  get fireServiceSize(): number {
    return this.fireCmpViewModel.fireServiceSize;
  }

  set fireServiceSize(v: number) {
    this.fireCmpViewModel.fireServiceSize = v;
  }

  get fireServiceFlow(): number {
    return this.fireCmpViewModel.fireServiceFlow;
  }

  set fireServiceFlow(v: number) {
    this.fireCmpViewModel.fireServiceFlow = v;
  }

  get fireServiceQty(): number {
    return this.fireCmpViewModel.fireServiceQty;
  }

  set fireServiceQty(v: number) {
    this.fireCmpViewModel.fireServiceQty = v;
  }


  get boosterYes(): boolean {
    return this.fireCmpViewModel.boosterYes;
  }

  set boosterYes(v: boolean) {
    this.fireCmpViewModel.boosterYes = v;
  }

  get boosterNo(): boolean {
    return this.fireCmpViewModel.boosterNo;
  }

  set boosterNo(v: boolean) {
    this.fireCmpViewModel.boosterNo = v;
  }

  get hydrantYes(): boolean {
    return this.fireCmpViewModel.hydrantYes;
  }

  set hydrantYes(v: boolean) {
    this.fireCmpViewModel.hydrantYes = v;
  }

  get hydrantNo(): boolean {
    return this.fireCmpViewModel.hydrantNo;
  }

  set hydrantNo(v: boolean) {
    this.fireCmpViewModel.hydrantNo = v;
  }

  get sprinklerYes(): boolean {
    return this.fireCmpViewModel.sprinklerYes;
  }

  set sprinklerYes(v: boolean) {
    this.fireCmpViewModel.sprinklerYes = v;
  }

  get sprinklerNo(): boolean {
    return this.fireCmpViewModel.sprinklerNo;
  }

  set sprinklerNo(v: boolean) {
    this.fireCmpViewModel.sprinklerNo = v;
  }

  get hoseReelYes(): boolean {
    return this.fireCmpViewModel.hoseReelYes;
  }

  set hoseReelYes(v: boolean) {
    this.fireCmpViewModel.hoseReelYes = v;
  }

  get hoseReelNo(): boolean {
    return this.fireCmpViewModel.hoseReelNo;
  }

  set hoseReelNo(v: boolean) {
    this.fireCmpViewModel.hoseReelNo = v;
  }

  get pumpYes(): boolean {
    return this.fireCmpViewModel.pumpYes;
  }

  set pumpYes(v: boolean) {
    this.fireCmpViewModel.pumpYes = v;
  }

  get pumpNo(): boolean {
    return this.fireCmpViewModel.pumpNo;
  }

  set pumpNo(v: boolean) {
    this.fireCmpViewModel.pumpNo = v;
  }

  get tankYes(): boolean {
    return this.fireCmpViewModel.tankYes;
  }

  set tankYes(v: boolean) {
    this.fireCmpViewModel.tankYes = v;
  }

  get tankNo(): boolean {
    return this.fireCmpViewModel.tankNo;
  }

  set tankNo(v: boolean) {
    this.fireCmpViewModel.tankNo = v;
  }

  get designStandards(): string {
    return this.fireCmpViewModel.workrequestDetails.designStandards;
  }

  set designStandards(v: string) {
    this.fireCmpViewModel.workrequestDetails.designStandards = v;
  }

  get invalid(): boolean {
    return !((this.fireServiceYes || this.fireServiceNo) && (!this.fireServiceYes || this.hydrantYes || this.boosterYes || this.hoseReelYes || this.pumpYes || this.tankYes || this.sprinklerYes));
  }

  set fireServiceYes(v: boolean) {
    this.fireCmpViewModel.fireServiceYes = v;

    if (v) {
      this.fireCmpViewModel.fireServiceNo = !v;
      if (this.fireServiceYes) {
        this.disableControls(false);
      }

    } else {
      this.disableControls(true);
    }
  }

  set fireServiceNo(v: boolean) {
    this.fireCmpViewModel.fireServiceNo = v;
    if (v) {
      this.fireCmpViewModel.fireServiceYes = !v;
      this.disableControls(true);
    } else {
      if (this.fireServiceNo) {
        this.disableControls(true);
      }
    }
  }
  disableControls(v: boolean) {
    if (v) {
      this.boosterYesControl.disable();
      this.boosterNoControl.disable();
      this.hydrantYesControl.disable();
      this.hydrantNoControl.disable();
      this.sprinklerYesControl.disable();
      this.sprinklerNoControl.disable();
      this.hoseReelYesControl.disable();
      this.hoseReelNoControl.disable();
      this.pumpYesControl.disable();
      this.pumpNoControl.disable();
      this.tankYesControl.disable();
      this.tankNoControl.disable();
      this.designStandardsControl.disable();
      this.boosterYesControl.setValue(false);
      this.boosterNoControl.setValue(false);
      this.hydrantYesControl.setValue(false);
      this.hydrantNoControl.setValue(false);
      this.sprinklerYesControl.setValue(false);
      this.sprinklerNoControl.setValue(false);
      this.hoseReelYesControl.setValue(false);
      this.hoseReelNoControl.setValue(false);
      this.pumpYesControl.setValue(false);
      this.pumpNoControl.setValue(false);
      this.tankYesControl.setValue(false);
      this.tankNoControl.setValue(false);
      this.designStandardsControl.setValue('');
    } else {

      this.boosterYesControl.enable();
      this.boosterNoControl.enable();
      this.hydrantYesControl.enable();
      this.hydrantNoControl.enable();
      this.sprinklerYesControl.enable();
      this.sprinklerNoControl.enable();
      this.hoseReelYesControl.enable();
      this.hoseReelNoControl.enable();
      this.pumpYesControl.enable();
      this.pumpNoControl.enable();
      this.tankYesControl.enable();
      this.tankNoControl.enable();
      this.designStandardsControl.enable();
    }
  }

  displayErrorMessage(): string {
    this.fireServiceControlGroup.markAsTouched();
    this.boosterControlGroup.markAsTouched();
    this.hydrantControlGroup.markAsTouched();
    this.sprinklerControlGroup.markAsTouched();
    this.hoseReelControlGroup.markAsTouched();
    this.pumpControlGroup.markAsTouched();
    this.tankControlGroup.markAsTouched();
    this.designStandardsControl.markAsTouched();

    this.fireServiceSizeControl.markAsTouched();
    this.fireServiceFlowControl.markAsTouched();
    this.fireServiceQtyControl.markAsTouched();

    this.errorMessage = null;

    let errorText = '';
    if (this.fireServiceControlGroup.hasError('yesOrNo')) {
      errorText += 'Please select yes or no to property has Fire services related works <br>';
    }
    else {

      if (this.fireServiceSizeControl.invalid) {
        errorText += 'Please enter fire service tapping size from 0 to ' + this.maximumFireServiceSize + ' mm' + '<br>';
      }
      if (this.fireServiceFlowControl.invalid) {
        errorText += 'Please enter fire service flow rate from 0 to ' + this.maximumFireServiceFlowRate + ' L/s' + '<br>';
      }
      if (this.fireServiceQtyControl.invalid) {
        errorText += 'Please enter fire service quantity from 0 to ' + this.maximumFireServiceQty + '<br>';
      }

      if (this.boosterControlGroup.hasError('yesOrNo')) {
        errorText += 'Please select yes or no to Booster Fire Cabinet/s question <br>';
      }

      if (this.hydrantControlGroup.hasError('yesOrNo')) {
        errorText += 'Please select yes or no to Hydrants question <br>';
      }

      if (this.sprinklerControlGroup.hasError('yesOrNo')) {
        errorText += 'Please select yes or no to Fire Sprinkler System question <br>';
      }

      if (this.hoseReelControlGroup.hasError('yesOrNo')) {
        errorText += 'Please select yes or no to Hose Reels question <br>';
      }

      if (this.pumpControlGroup.hasError('yesOrNo')) {
        errorText += 'Please select yes or no to In-Line Pumps  question <br>';
      }

      if (this.tankControlGroup.hasError('yesOrNo')) {
        errorText += 'Please select yes or no to Water Holding Tanks question <br>';
      }

      if (this.designStandardsControl.hasError('maxlength')) {
        errorText += 'Fire Service Design Standard/s field cannot exceed ' +
          this.designStandardsControlMaxLength + ' characters' + '<br>';
      }

      if (this.invalid) {
        errorText += 'Please select at least one option.<br>'
      }
    }
    this.markValidationControlsAsUntouched();

    this.errorMessage = errorText.length > 0 ? errorText : null;
    return errorText;
  }

  markValidationControlsAsUntouched() {
    this.fireServiceControlGroup.markAsUntouched();
    this.boosterControlGroup.markAsUntouched();
    this.hydrantControlGroup.markAsUntouched();
    this.sprinklerControlGroup.markAsUntouched();
    this.hoseReelControlGroup.markAsUntouched();
    this.pumpControlGroup.markAsUntouched();
    this.tankControlGroup.markAsUntouched();
    this.designStandardsControl.markAsUntouched();

    this.fireServiceSizeControl.markAsUntouched();
    this.fireServiceFlowControl.markAsUntouched();
    this.fireServiceQtyControl.markAsUntouched();
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/cmp-form/fire-cmp/fire-cmp.component.ts